if (!customElements.get('csc-make-grid')) {
  customElements.define('csc-make-grid', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const items = [...this.querySelectorAll('[data-make-model]')];
      const button = this.querySelector('[data-show-models]');
      items.forEach((item, index) => item.hidden = index >= 20);
      if (button) button.hidden = items.length <= 20;
      button?.addEventListener('click', () => {
        items.forEach(item => item.hidden = false);
        button.setAttribute('aria-expanded', 'true');
        button.hidden = true;
        items[20]?.querySelector('a')?.focus();
      }, options);
      const make = this.querySelector('[data-finder-make]');
      const model = this.querySelector('select:not([data-finder-make])');
      const submit = this.querySelector('[type="submit"]');
      const initialMake = make.value;
      let vehicles = [];
      try { vehicles = JSON.parse(document.querySelector('[data-picker-data]').textContent); } catch (_) { /* Existing current-make options remain usable. */ }
      if (vehicles.length) {
        make.replaceChildren(...[...new Set(vehicles.map(row => row.make))].sort((a,b)=>a.localeCompare(b)).map(value => new Option(value,value,value===initialMake,value===initialMake)));
        if (!initialMake) {
          make.insertBefore(new Option('Choose your make','',true,true), make.firstChild);
          make.value = '';
        }
      }
      submit.disabled = !model.value;
      make.addEventListener('change', () => {
        const matches = vehicles.filter(row => row.make === make.value && /^\/products\/[^/?#]+-car-window-shades$/.test(row.url)).sort((a,b)=>a.model.localeCompare(b.model));
        model.replaceChildren(new Option('Choose your model',''), ...matches.map(row=>new Option(row.model,row.url)));
        model.disabled = matches.length === 0;
        submit.disabled = true;
        if (!model.disabled) model.focus();
      }, options);
      model.addEventListener('change', () => { submit.disabled = !model.value; }, options);
      this.querySelector('form').addEventListener('submit', event => {
        event.preventDefault();
        const target = model.value;
        if (target.startsWith('/products/')) window.location.assign(target);
      }, options);
      this.setAttribute('data-enhanced', '');
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
